import CurrentOffer from "./offers/current-offers";

const Offers: React.FC = () => {
  return (
    <div>
      <div className="mt-1">
        <h3 className="text-xl font-semibold text-[#111827]">
          Offers Management
        </h3>
        <CurrentOffer />
      </div>
    </div>
  );
};

export default Offers;
